import { render, staticRenderFns } from "./DecompositionFilters.vue?vue&type=template&id=01b4d976"
import script from "./DecompositionFilters.vue?vue&type=script&lang=js"
export * from "./DecompositionFilters.vue?vue&type=script&lang=js"
import style0 from "./DecompositionFilters.vue?vue&type=style&index=0&id=01b4d976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports